// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".csvbox-iframe{height:100%;width:100%;position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
